var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.5C3.17157 1.5 2.5 2.17157 2.5 3V13C2.5 13.8284 3.17157 14.5 4 14.5L4 10.5C4 10.2239 4.22386 10 4.5 10L11.5 10C11.7761 10 12 10.2239 12 10.5V14.5C12.8284 14.5 13.5 13.8284 13.5 13V9.16667V5.20823C13.5 4.94224 13.4293 4.68103 13.2951 4.45138L12.0045 2.24315C11.7356 1.78291 11.2425 1.5 10.7095 1.5H10.5V3.5C10.5 3.77614 10.2761 4 10 4H6C5.72386 4 5.5 3.77614 5.5 3.5V1.5H4ZM1.5 3C1.5 1.61929 2.61929 0.5 4 0.5H10.7095C11.5979 0.5 12.4196 0.971519 12.8679 1.73858L14.1584 3.94681C14.3821 4.32956 14.5 4.76491 14.5 5.20823V9.16667V13C14.5 14.3807 13.3807 15.5 12 15.5H4C2.61929 15.5 1.5 14.3807 1.5 13V3Z",
    fill: "#CACACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.c1fc1512fb2060e8da7ec3c2e89496b5.svg";
export { ForwardRef as ReactComponent };